import { defaultIconProps, IconProps } from './IconProps';

export const IconStackRight: import('react').FC<IconProps> = ({ size, color, ...rest }) => (
  <svg width={size} height={size} viewBox="0 0 13 14" fill="none" xmlns="http://www.w3.org/2000/svg" {...rest}>
    <path d="M12.5 13L12.5 1M5.83333 11L9.83333 7M9.83333 7L5.83333 3M9.83333 7L0.5 7" stroke={color} strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

IconStackRight.defaultProps = defaultIconProps;
